import {Component, OnDestroy, OnInit} from '@angular/core';
import { Area } from '@core/area';
import {ParkService} from "@core/park/park.service";
import {ThingService} from "@core/thing/thing.service";
import { KngActivityIndicatorService } from '@layout/kingswell/services/kngActivityIndicator.service';
import { SUPPLY, CART_BANANA_BOAT, DUMPSTER, THINGS_LIST_TABS } from '../../../constants/things.constants';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { KngDrawerService } from '@layout/kingswell/kingswell';
import { ResourcesFilterComponent } from '@components/resources/filter/filter.component';
import { ParkUtil } from '../../../util/park';
import _ from "lodash";
import { Kingdom } from '@core/kingdom';
import { Route } from '@angular/compiler/src/core';
import { ThingModalEvent } from '@events/ThingModalEvent';
import { ThingConfig } from '@core/thing/thingConfig';
import { ThingsUtil } from '../../../util/things';
import { RefreshEvent } from '@events/RefreshEvent';
import { MainKngContentScrollEvent } from '@events/MainKngContentScrollEvent';
import {Subscription} from "rxjs/Subscription";

export class ResourceFilter {
  text:string = '';
  areas: Array<string> = [];
  types: Array<string> = [];
  property: Kingdom;
  worldId: string;
  kingdomId: string;
  constructor() {}
}

@Component({
  selector: 'resources-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.less']
})
export class ResourcesListComponent implements OnInit, OnDestroy {

  public worlds = [];
  public activeWorld;
  public things = {};
  public kingdoms = [];

  public worldFilter;

  public filters: ResourceFilter;

  public config: ThingConfig;

  public showStickyHeader: boolean = false;

  private refresherSubscription: Subscription;
  private mainKngContentScrollSubscription: Subscription;

  constructor(private park: ParkService, private thing: ThingService,
     private kngActivityIndicator: KngActivityIndicatorService, private router: Router,
     private kngDrawerService: KngDrawerService, private parkUtil: ParkUtil,
     private route: ActivatedRoute, private thingModal: ThingModalEvent,
    private thingsUtil: ThingsUtil, private refresher: RefreshEvent,
    private mainKngContentScrollEvent: MainKngContentScrollEvent) { }

  ngOnInit() {
    this.config = this.thingsUtil.getConfigByTabName('resources');

    this.kngActivityIndicator.show();
    this.refreshData().then(() => {
      this.kngActivityIndicator.close();
      this.route.queryParams.subscribe(params =>{
        this.onParameterChange(params);
      });
    }).catch(err => {
      this.kngActivityIndicator.close();
    });

    this.refresherSubscription = this.refresher.on().subscribe(data => {
      if (data === 'resourcesList.refresh') {
        this.kngActivityIndicator.show();
        this.refreshThings().then(() => {
          this.kngActivityIndicator.close();
        }).catch(err => {
          console.log('ERROR', err);
          this.kngActivityIndicator.close();
        });
      }
    });

    this.mainKngContentScrollSubscription = this.mainKngContentScrollEvent.on()
      .subscribe((topScroll) => {
        this.showStickyHeader = (topScroll > 186);
      });
  }

  ngOnDestroy(): void {
    if (this.refresherSubscription)
      this.refresherSubscription.unsubscribe();
    if (this.mainKngContentScrollSubscription)
      this.mainKngContentScrollSubscription.unsubscribe();
  }

  onParameterChange(params) {
    let worldChanged = false;

    if (params.areas) {
      this.filters.areas = params.areas && params.areas.split(',');
    }

    if (params.types) {
      this.filters.types = params.types && params.types.split(',');
    }

    if (params.site) {
      if (params.site !== this.filters.worldId) {
        worldChanged = true;
      }
      this.filters.worldId = params.world;
    }

    if (params.property) {
      this.filters.property = this.kingdoms.find(kingdom => kingdom.kingdomId === params.property);
      this.kingdoms = [this.filters.property];
    }

    let promises = [];

    if (worldChanged) {
      promises.push(this.refreshData());
    }

    this.kngActivityIndicator.show();
    Promise.all(promises).then(() => {
      this.refreshThings().then(() => {
        this.kngActivityIndicator.close();
      }).catch(err => {
        this.kngActivityIndicator.close();
      });
    }).catch(err => {
      console.log('ERR', err);
      this.kngActivityIndicator.close();
    });
  }

  refreshData() {
    return new Promise((resolve, reject) => {
      this.thing.reloadThingDataLazy(); // just flag to reload the thing data, but only builds the data as lazy loading
      this.park.reloadWorldsKingdomsLands().then(res => {
        this.worlds = res.worlds;
        if (! this.activeWorld) {
          this.activeWorld = this.worlds && this.worlds[0];
        }

        this.kingdoms = this.parkUtil.getAllActiveKingdomsForWorld(this.activeWorld);

        this.filters = new ResourceFilter();
        let allAreas = this.parkUtil.getAllActiveAreasForWorld(this.activeWorld);
        this.filters.areas = allAreas.map(a => a.areaId);
        this.filters.types = [SUPPLY, CART_BANANA_BOAT, DUMPSTER];
        this.filters.worldId = this.activeWorld.worldId;

        resolve();
      }).catch(err => {
        console.log('ERROR', err);
        reject(err);
      });
    });
  }

  refreshThings() {
    return new Promise((resolve, reject) => {
      this.thing.getThingsGroupedByKingdom({
        areas: this.filters.areas.join(','),
        types: this.filters.types.join(',')
      }).then(things => {
        this.things = things;

        resolve(this.things);
        //this.filteredThings = this.things;
      }).catch(err => {
        reject(err);
      });
    });
  }

  addResource($event) {
    $event.preventDefault();
    $event.stopPropagation();
    // open add resource panel

    this.thingModal.fire('thingsAdd.open', {});
  }

  gotoThing(thing) {
    this.router.navigate(['things',thing.thingId]);
  }

  openFilters($event) {
    $event.preventDefault();
    $event.stopPropagation();

    let drawer = this.kngDrawerService.launch(ResourcesFilterComponent,{
      windowClass: "kng-filter-drawer"
    });
    drawer.componentInstance.world = this.activeWorld;
    drawer.componentInstance.selectedAreas = this.filters.areas;
    drawer.componentInstance.selectedResources = this.filters.types;
    drawer.componentInstance.property = this.filters.property;
    drawer.result.then(res=>{
      this.filters.areas = res.selectedAreas;
      this.filters.types = res.selectedResources;
      this.filters.property = res.property;
      this.filters.kingdomId = res.property && res.property.kingdomId;
      this.kngActivityIndicator.show();

      if (this.filters.property) {
        this.kingdoms = [this.filters.property];
      } else {
        this.kingdoms = this.parkUtil.getAllActiveKingdomsForWorld(this.activeWorld);
      }

      this.updateUrl({
        areas: this.filters.areas.join(','),
        types: this.filters.types.join(','),
        property: this.filters.property && this.filters.property.kingdomId
      });

      this.refreshThings().then(() => {
        this.kngActivityIndicator.close();
      });
    }).catch(err=>{

    });

  }

  updateUrl(params){
    let navExtra :NavigationExtras = {
      queryParamsHandling: "merge",
      queryParams: params
    };

    this.router.navigate(['resources'], navExtra);
  }

  onWorldChange() {
    this.updateUrl({
      areas: undefined,
      types: undefined,
      property: undefined,
      site: this.activeWorld.worldId
    });
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/components/resources/list/list.component.ts